import { Box } from '@mui/material';
import styled, { css } from 'styled-components';

export const RoundPicture = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const NameCellContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  gap: 8px;
`;

export const Name = styled.div`
  font: ${({ theme }) => theme.fonts.textMiddleNormal};
  color: ${({ theme }) => theme.colors.greys.darkest};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NameHover = styled.div`
  background: ${({ theme }) => theme.colors.white};
  font: ${({ theme }) => theme.fonts.textMiddleNormal};
  position: absolute;
  padding: 8px 8px 8px 8px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

  ${(props) => {
    let offset = 0;

    if (props.offsetName) {
      offset += 50; // name column includes pictures on the left of the name
    }

    if (props.offsetCategory) {
      offset += 200; // entire name column width
    }

    return css`
      left: ${offset}px;
    `;
  }}
`;

export const Sku = styled.div`
  font: ${({ theme }) => theme.fonts.textSmallNormal};
  color: ${({ theme }) => theme.colors.greys.darker};
`;

export const HeaderCellContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;

  gap: 8px;
`;

export const TotalContainer = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
`;

// Styled DataGrid container to allow button overflow
export const StyledDataGridContainer = styled(Box)`
  height: 100%;
  width: 100%;

  // Styles for the pagination footer - same design as SupplierProductsDatagrid
  & .MuiDataGrid-footerContainer {
    min-height: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.colors.greys.lightest};
    justify-content: flex-start;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  & .MuiTablePagination-root {
    font-size: 14px;
  }
  & .MuiTablePagination-select {
    padding: 0;
    font-size: 14px;
  }

  & .MuiTablePagination-displayedRows {
    font-size: 14px;
    margin: 0;
    padding: 0;
  }
  & .MuiTablePagination-selectLabel {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
  & .MuiTablePagination-actions {
    margin-left: 8px;
    padding: 0;
  }
`;
